import React, { useState } from 'react';
import { X, Loader2 } from 'lucide-react';
import api from './api';

export default function ChangePasswordDialog({ onClose }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await api.post('/api/auth/change-password', { current_password: current, new_password: next });
      setDone(true);
      setTimeout(() => onClose(), 1500);
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setErr(typeof detail === 'string' ? detail : 'Failed to update password');
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-6" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-md bg-[#124D3A] border border-[#D4AF37]/20 rounded-3xl p-7 relative" data-testid="change-password-dialog">
        <button onClick={onClose} className="absolute top-4 right-4 text-white/60 hover:text-white"><X className="w-5 h-5" /></button>
        <h3 className="font-serif-display text-2xl text-white mb-5">Change password</h3>
        {done ? (
          <div className="text-sm text-emerald-300 bg-emerald-900/20 border border-emerald-400/30 px-4 py-2.5 rounded-xl">Password updated.</div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <Field label="Current password" value={current} onChange={setCurrent} testId="cp-current" />
            <Field label="New password (min 8 chars)" value={next} onChange={setNext} testId="cp-new" />
            {err && <div data-testid="cp-error" className="text-sm text-red-300 bg-red-900/20 border border-red-400/30 px-4 py-2.5 rounded-xl">{err}</div>}
            <button disabled={busy} data-testid="cp-submit" className="btn-gold w-full py-3 rounded-full text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />}
              {busy ? 'Saving…' : 'Update password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

function Field({ label, value, onChange, testId }) {
  return (
    <label className="block">
      <span className="block text-[11px] tracking-[0.18em] uppercase text-[#D4AF37] mb-2">{label}</span>
      <input
        type="password" required minLength={label.includes('New') ? 8 : 1}
        value={value} onChange={(e) => onChange(e.target.value)}
        data-testid={testId}
        className="w-full px-4 py-3 rounded-full bg-[#072A1F] border border-[#D4AF37]/25 text-white outline-none focus:border-[#D4AF37]"
      />
    </label>
  );
}
